export default "__VITE_ASSET__d60e3681__"